<div class="page-store">
  <div class="pe-page-content" >

    <app-header [executeLogic]="true" [layoutSetting]="layoutSettings" [header]="layoutSettings.header">
    </app-header>
    <div  class="pe-p-container dash-wrap-user">
      <router-outlet></router-outlet>
    </div>
    <app-footer [layoutSetting]="layoutSettings" [footer]="layoutSettings.footer" [logo]="layoutSettings.header.logo" [linksSocial]="socialLinks">
    </app-footer>
  </div>
</div>
